import { useRef } from 'react';

import { icon_chevron_down, icon_chevron_up } from '@gn-audio/icons';

import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { DISPLAY_VERSIONS } from '../../MegaMenu';

type MobileRegionItemProps = {
  ariaControls: string;
  region: string;
  id: string;
};
export const MobileRegionItem = ({ region, id, ariaControls }: MobileRegionItemProps) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div id={id} aria-controls={ariaControls}>
      <div
        className={`flex w-full cursor-pointer items-center justify-between px-5 py-2 ${DISPLAY_VERSIONS.MOBILE}`}
        ref={ref}
      >
        <strong>{region}</strong>
        <JabraIcon className="icon h-3 group-data-[state=open]:hidden" Icon={icon_chevron_down} />
        <JabraIcon className="icon h-3 group-data-[state=closed]:hidden" Icon={icon_chevron_up} />
      </div>
    </div>
  );
};
